import React, { useContext } from "react"
import { Button, Input } from "reactstrap"
import { isEmpty } from "lodash"
import Actions from "pages/Reports/VerifyMyTeams/ActionButton/Actions"
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"
import TeamsScreenTableContainer from "./TeamsScreenTableContainer"
import ViewScreenTableContainer from "./ViewScreenTableContainer"
import { MyContext } from "../../../pages/Reports/VerifyMyTeams/index"

const MobileTableUI = ({ itemdata, id, handleOnExpand, handleVerify }) => {
  const { pathname } = useLocation()
  const {
    toggleViewModal,
    setSelectedArrayLists,
    setSelectedReportItem,
    handleverifyScreen,
    selectedArrayLists,
    selectToggleTeam,
    Reporticon,
    Imageicon,
    summaryDatateam,
    handleverifyScreenproject,
    fullviewteamreport,
    renderWorkStatus,
    projectreport,
    summaryData,
    handleverifyScreenrow,
    isMobileTeam,
    compactView,
    classnames,
  } = useContext(MyContext) || {}
  const renderArrList = pathname === "/verifyscreen" ? itemdata : itemdata?.[id]

  return (
    <>
      {(renderArrList || []).map((el, idx) => (
        <div key={idx}>
          {pathname !== "/verifyscreen" && !selectToggleTeam && (
            <div className="text-center d-block mb-2 text-uppercase font-weight-bold">
              Team Members
            </div>
          )}
          <table className="table table-align-mobile" key={idx}>
            <tbody>
              {pathname === "/verifyscreen" ? (
                <ViewScreenTableContainer el={el} />
              ) : (
                <TeamsScreenTableContainer
                  el={el}
                  selectToggle={selectToggleTeam}
                  compactView={compactView}
                />
              )}
              {pathname !== "/verifyscreen" && selectToggleTeam && (
                <tr>
                  <th scope="row" className="text-uppercase">
                    Action
                  </th>
                  <td>
                    <Actions
                      Reporticon={Reporticon}
                      Imageicon={Imageicon}
                      summaryDatateam={summaryDatateam}
                      handleverifyScreenproject={handleverifyScreenproject}
                      fullviewteamreport={fullviewteamreport}
                      renderWorkStatus={renderWorkStatus}
                      classnames={classnames}
                      projectreport={projectreport}
                      row={el}
                      selectToggle={selectToggleTeam}
                      summaryData={summaryData}
                      handleverifyScreenrow={handleverifyScreenrow}
                      isMobile={isMobileTeam}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="mb-2">
            {pathname !== "/verifyscreen" && (
              <div>
                {!selectToggleTeam && (
                  <Input
                    type="checkbox"
                    className="form-check-Input me-3"
                    id="horizontal-customCheck"
                    defaultChecked
                    checked={
                      (selectedArrayLists || []).findIndex(
                        ele => el.userId === ele.userId
                      ) > -1
                    }
                    onClick={e => {
                      const checkAlreadyExists = selectedArrayLists.filter(
                        ele => ele?.userId === el?.userId
                      )
                      if (!isEmpty(checkAlreadyExists)) {
                        const FilteredLists = selectedArrayLists.filter(
                          ele => ele?.userId !== el?.userId
                        )
                        setSelectedArrayLists(FilteredLists)
                      } else {
                        const AddedCheckedLists = [...selectedArrayLists, el]
                        setSelectedArrayLists(AddedCheckedLists)
                      }
                    }}
                  />
                )}
                <span className="mb-2 text-uppercase font-weight-bold">
                  Report:{" "}
                </span>
              </div>
            )}

            {pathname !== "/verifyscreen" && (
              <div
                className="input-static-widthteams "
                style={{
                  background: "#fff",
                  marginBottom: "1rem",
                  minHeight: "80px",
                  borderBottomWidth: "2px",
                }}
                dangerouslySetInnerHTML={{
                  __html:
                    el?.workReportSummary?.projectSummaryList?.[0]
                      .workReportDetails,
                }}
              />
            )}

            <div style={{ display: "flex", flexDirection: "row" }}>
              <Button
                color="primary me-3 "
                onClick={e => {
                  if (pathname === "/verifyscreen") {
                    handleOnExpand(el)
                  } else {
                    handleverifyScreen(el)
                  }
                }}
              >
                {pathname === "/verifyscreen"
                  ? "Verify Screen"
                  : "View Screens"}
              </Button>
              <Button
                color="primary"
                onClick={e => {
                  if (pathname === "/verifyscreen") {
                    handleVerify(el)
                  } else {
                    toggleViewModal(el)
                    {
                      !selectToggleTeam && setSelectedReportItem(el)
                    }
                  }
                }}
              >
                View Report
              </Button>
            </div>
          </div>
          {pathname !== "/verifyscreen" ||
            (!selectToggleTeam && (
              <span className="mb-4 text-center d-block">
                <hr />
              </span>
            ))}
        </div>
      ))}
    </>
  )
}
export default MobileTableUI
